// extracted by mini-css-extract-plugin
export var emptyHeader = "styles-module__emptyHeader___goZkB";
export var emptyText = "styles-module__emptyText___jvCEJ";
export var infoButton = "styles-module__infoButton___k59u7";
export var reviewLink = "styles-module__reviewLink___BlzFp";
export var modalContent = "styles-module__modalContent___ISMdT";